import { capitalize } from 'lodash';
import moment from 'moment-timezone';
import { compose, withHandlers, withProps } from 'recompose';
import { formatDuration } from '../utils/helpers';

const ADD_TO_CALENDAR_DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const addressToString = (address) => {
  if (!address) return '';
  if (typeof address === 'string') return address;

  const { street, street2, city, state, zip, country } = address;
  return [street, street2, city, state, zip, country].filter(Boolean).join(', ');
};

const formatServicesForDescription = (appt, commaSeparatedServicesStr) => {
  const services = appt.appointment_service || [];
  if (!services.length) return commaSeparatedServicesStr.split(',').map(s => '  '.concat(s)).join('<br/>');
  return services.map(s => `  ${[s.name, s.desc].filter(Boolean).join(' – ')}<br/>`);
};

export default compose(
  withProps((props) => {
    const { shop, appointment, serviceName, barberName, customer } = props;
    const apptTime = appointment.dateTime || appointment.start;
    const apptTimeString = moment.tz(apptTime, shop.timezone);
    const servicesForDescription = formatServicesForDescription(appointment, serviceName);

    return {
      startTime: apptTimeString.format(ADD_TO_CALENDAR_DATE_FORMAT),
      finishTime: moment(apptTimeString).add(appointment.duration, 'minutes').format(ADD_TO_CALENDAR_DATE_FORMAT),
      timezone: shop.timezone,
      title: capitalize(serviceName),
      location: addressToString(shop.address),
      organizer: customer.name,
      organizerEmail: customer.email,
      description: `
        Confirmation Code: ${appointment.confirmationCode}
        Barber: ${barberName}
        Client: ${customer.name || [customer.firstName, customer.lastName].filter(Boolean).join(' ')}
        Duration: ${formatDuration(appointment.duration)}
        Services:
        ${servicesForDescription}
      `,
    };
  }),
  withHandlers({
    getCalendarLink: props => calendarType => (
      `https://addtocalendar.com/atc/${calendarType}?f=m&e`
        .concat(`[0][date_start]=${encodeURIComponent(props.startTime)}&e`)
        .concat(`[0][date_end]=${encodeURIComponent(props.finishTime)}&e`)
        .concat(`[0][timezone]=${props.timezone}&e`)
        .concat(`[0][title]=${encodeURIComponent(props.title)}&e`)
        .concat(`[0][location]=${encodeURIComponent(props.location)}&e`)
        .concat(`[0][organizer]=${encodeURIComponent(props.organizer)}&e`)
        .concat(`[0][organizer_email]=${encodeURIComponent(props.organizerEmail)}&e`)
        .concat(`[0][description]=${encodeURIComponent(props.description)}&e`)
        .concat('[0][privacy]=public')
    ),
  }),
);



// WEBPACK FOOTER //
// ./src/app/components/AddToCalendarContainer.jsx